export var HipaaStatus;
(function (HipaaStatus) {
    HipaaStatus["SUBSCRIBED"] = "Subscribed";
    HipaaStatus["INACTIVE"] = "Inactive";
})(HipaaStatus || (HipaaStatus = {}));
export var PandaDocStatus;
(function (PandaDocStatus) {
    PandaDocStatus["DOCUMENT_UPLOADED"] = "document.uploaded";
    PandaDocStatus["DOCUMENT_DRAFT"] = "document.draft";
    PandaDocStatus["DOCUMENT_SENT"] = "document.sent";
    PandaDocStatus["DOCUMENT_VIEWED"] = "document.viewed";
    PandaDocStatus["DOCUMENT_COMPLETED"] = "document.completed";
    PandaDocStatus["DOCUMENT_VOIDED"] = "document.voided";
})(PandaDocStatus || (PandaDocStatus = {}));
export var WarningInstance;
(function (WarningInstance) {
    WarningInstance["DOCUMENT_EXPIRED"] = "document_expired";
    WarningInstance["DOCUMENT_CREATION_FAILED"] = "document_creation_failed";
})(WarningInstance || (WarningInstance = {}));
export var HipaaRecipientTypes;
(function (HipaaRecipientTypes) {
    HipaaRecipientTypes["OWNER"] = "owner";
    HipaaRecipientTypes["ADMIN"] = "admin";
})(HipaaRecipientTypes || (HipaaRecipientTypes = {}));
